// extracted by mini-css-extract-plugin
module.exports = {"t1lxy6gw":"t1lxy6gw","inner":"inner","t15nvgb":"t15nvgb","no-border":"no-border","t1vb1gsz":"t1vb1gsz"};